<template>

  <div class='print-order-doc' id='print-section'>
    <div class='print-order-doc__header'>
      <div class='print-order-doc__header__logo'>
        <svg width='168' height='92' viewBox='0 0 168 92' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <g clip-path='url(#clip0_2_135)'>
            <path
              d='M148.125 82.4619C148.124 82.588 148.15 82.7127 148.202 82.8279C148.253 82.9432 148.328 83.0462 148.422 83.1303C148.516 83.2143 148.626 83.2775 148.747 83.3155C148.867 83.3536 148.994 83.3658 149.119 83.3512L158.281 82.2803C158.406 82.265 158.533 82.2766 158.654 82.3143C158.774 82.352 158.885 82.415 158.979 82.499C159.074 82.583 159.149 82.6861 159.2 82.8015C159.251 82.9169 159.278 83.0419 159.277 83.1681C159.276 83.3978 159.191 83.6193 159.039 83.7908C158.886 83.9623 158.676 84.0719 158.448 84.099L138.538 86.3732L138.529 64.4775C138.529 58.8048 142.957 53.4953 148.617 52.6996C154.468 51.8782 159.262 56.0447 159.269 61.8746V71.2197L150.723 72.194L150.716 62.2598C150.726 61.8481 150.58 61.4479 150.309 61.1382C150.038 60.8285 149.661 60.6319 149.251 60.5872C148.973 60.5749 148.696 60.6184 148.434 60.7152C148.173 60.812 147.934 60.9601 147.731 61.1508C147.528 61.3415 147.366 61.571 147.253 61.8256C147.14 62.0803 147.079 62.3549 147.074 62.6334L147.082 76.2664L160.551 74.7257C160.676 74.7108 160.803 74.7226 160.923 74.7604C161.044 74.7983 161.154 74.8613 161.248 74.9453C161.342 75.0293 161.417 75.1323 161.468 75.2475C161.519 75.3628 161.545 75.4875 161.545 75.6136V75.649C161.544 75.8787 161.459 76.1002 161.306 76.2717C161.154 76.4431 160.943 76.5528 160.715 76.5799L146.243 78.2337C146.015 78.2621 145.805 78.3723 145.653 78.5438C145.5 78.7153 145.415 78.9364 145.413 79.166C145.413 79.2924 145.44 79.4174 145.492 79.5327C145.543 79.648 145.619 79.751 145.713 79.835C145.808 79.919 145.919 79.9821 146.039 80.02C146.16 80.058 146.287 80.0701 146.412 80.0554L162.987 78.2079C163.111 78.1933 163.238 78.2054 163.358 78.2432C163.477 78.2811 163.588 78.344 163.681 78.4277C163.775 78.5113 163.85 78.614 163.901 78.7287C163.952 78.8435 163.978 78.9678 163.978 79.0934C163.978 79.3249 163.892 79.5482 163.738 79.7205C163.583 79.8929 163.371 80.0022 163.141 80.0276L148.955 81.5295C148.727 81.5568 148.516 81.6667 148.363 81.8384C148.21 82.0101 148.126 82.2319 148.125 82.4619Z'
              fill='#090A0A' />
            <path
              d='M99.4287 78.6705L89.4722 79.8088C88.9757 79.8743 88.519 80.1155 88.1849 80.4888C87.8509 80.862 87.6614 81.3426 87.6509 81.8435C87.645 82.0757 87.69 82.3063 87.7825 82.5193C87.875 82.7323 88.0129 82.9225 88.1865 83.0766C88.3601 83.2307 88.5653 83.3451 88.7877 83.4117C89.0101 83.4782 89.2443 83.4954 89.474 83.462L103.075 81.9071L103.069 69.6867L112.18 68.6449L112.19 89.432L90.3458 91.9293C84.6871 92.5763 79.8925 88.6798 79.742 83.0238C79.5872 77.1753 84.2845 71.8333 90.1017 71.1681L99.4239 70.1024L99.4287 78.6705Z'
              fill='#090A0A' />
            <path
              d='M123.696 75.3297L123.691 65.4141C123.686 65.0075 123.799 64.6081 124.016 64.2644C124.233 63.9206 124.545 63.6473 124.914 63.4773C126.173 62.9316 127.335 63.7249 127.336 64.9319L127.342 78.5663L115.152 79.9598L115.156 89.0936L135.893 86.7229L135.883 64.8249C135.88 59.1522 131.441 54.8548 125.785 55.3541C119.934 55.8707 115.143 61.1301 115.146 66.9614L115.15 76.307L123.696 75.3297Z'
              fill='#090A0A' />
            <path d='M99.3905 68.2201L94.027 63.4587L99.3852 57.472L104.749 62.233L99.3905 68.2201Z' fill='#090A0A' />
            <path
              d='M112.337 1.93057C112.514 13.136 112.691 26.9548 112.859 38.1602C112.859 38.3967 112.868 38.6424 112.868 38.9181C110.537 39.1737 108.276 39.4294 106.024 39.6659C105.091 39.7785 104.152 39.8377 103.212 39.8432C102.081 39.8236 101.855 39.5188 101.835 38.2691C101.667 27.565 101.511 15.8259 101.344 5.12269L92.3753 7.02362C92.4934 14.953 92.6147 22.8791 92.7392 30.8021C92.7784 33.7242 92.8276 36.6458 92.8572 39.5675C92.8673 40.6102 92.6213 40.9151 91.687 41.1922C91.4809 41.2473 91.2701 41.2835 91.0574 41.3002C89.4645 41.4775 87.8716 41.6739 86.2882 41.8316C85.2555 41.93 84.2133 42.0285 83.1906 42.0285C82.1484 42.0185 81.9125 41.694 81.901 40.5724C81.8026 34.6503 81.7142 27.4112 81.6144 21.4885L72.6561 23.7297C72.7349 29.5539 72.8333 35.3776 72.9117 41.2018C72.9413 42.9431 72.6366 43.3073 71.0632 43.4841C68.1524 43.8186 65.2417 44.1335 62.3309 44.4484C62.1833 44.468 62.0357 44.468 61.8293 44.4775C61.8293 44.1908 61.8193 43.9466 61.8193 43.7005C61.6521 32.6031 61.3794 17.5137 61.2117 6.40719L52.34 8.46199C52.5368 20.9466 52.7861 40.6518 52.9829 53.1464L73.7867 50.7323C75.7144 50.5473 77.5514 49.8246 79.0886 48.6464C79.1814 48.595 79.2852 48.5663 79.3912 48.5629C79.4973 48.5595 79.6026 48.5814 79.6985 48.6268C81.4327 49.5108 83.3922 49.8536 85.3233 49.6107C88.1357 49.324 90.9481 48.9895 93.7605 48.5594C95.619 48.2641 97.4479 47.7528 99.0704 46.464C99.1516 46.4119 99.2445 46.3809 99.3407 46.374C99.4369 46.3671 99.5334 46.3844 99.6212 46.4243C101.387 47.3296 103.385 47.6794 105.353 47.4279C116.121 46.2768 126.885 45.0964 137.646 43.8864C139.418 43.6555 141.17 43.2937 142.888 42.8041C144.599 42.397 146.084 41.3382 147.028 39.8528C147.592 38.9447 147.986 37.9404 148.188 36.89C151.913 36.4867 154.038 36.1522 157.765 35.7293C158.177 35.6811 158.557 35.4831 158.833 35.173C159.108 34.8629 159.261 34.4622 159.26 34.0472C159.26 33.8092 159.21 33.5737 159.113 33.3563C159.016 33.1388 158.875 32.9443 158.697 32.7855C158.52 32.6267 158.311 32.5071 158.085 32.4346C157.858 32.3621 157.618 32.3382 157.382 32.3647C153.881 32.7584 138.482 34.5385 133.654 35.0603C133.418 35.085 133.18 35.0599 132.955 34.9866C132.729 34.9134 132.522 34.7936 132.346 34.635C132.17 34.4764 132.029 34.2826 131.932 34.0662C131.836 33.8497 131.786 33.6153 131.785 33.3782C131.784 33.0185 131.898 32.6679 132.111 32.3777C132.323 32.0874 132.623 31.8727 132.966 31.765H132.976C138.128 31.214 164.644 28.3587 166.504 28.1523C166.55 28.1483 166.597 28.1383 166.641 28.1227H166.651C167.032 28.0447 167.373 27.8376 167.619 27.5365C167.864 27.2354 167.999 26.8588 167.999 26.4702C168 26.026 167.827 25.599 167.515 25.2822C167.204 24.9653 166.78 24.7842 166.336 24.7781C166.264 24.7766 166.192 24.7799 166.12 24.7882C164.369 24.985 138.138 27.7987 134.913 28.1452C134.677 28.1706 134.438 28.146 134.212 28.073C133.987 28 133.779 27.8802 133.603 27.7215C133.426 27.5627 133.285 27.3685 133.189 27.1516C133.093 26.9347 133.043 26.6999 133.044 26.4626C133.043 26.0807 133.171 25.7098 133.409 25.4111C133.647 25.1124 133.979 24.9038 134.352 24.8197C138.993 24.3275 158.67 22.2326 161.895 21.8684C161.922 21.8666 161.949 21.8599 161.974 21.8488C162.369 21.7858 162.729 21.5837 162.989 21.279C163.248 20.9742 163.391 20.5868 163.39 20.1864C163.39 19.9483 163.34 19.7129 163.243 19.4955C163.146 19.2782 163.005 19.0837 162.827 18.9249C162.65 18.7662 162.441 18.6466 162.215 18.5741C161.988 18.5016 161.749 18.4778 161.512 18.5043C158.287 18.8684 151.128 19.5962 147.903 19.9503C147.586 18.1225 146.785 16.4134 145.582 15.0015C143.488 12.6122 140.724 11.9619 137.696 12.2075C134.323 12.4827 131.146 13.7916 128.167 15.7097C125.915 17.1562 123.781 18.8283 121.559 20.4224C121.559 20.3144 121.558 20.0879 121.549 19.8619C121.47 14.462 121.382 5.4008 121.303 0L112.337 1.93057Z'
              fill='#090A0A' />
            <path d='M22.2588 30.5722L16.5337 25.3745L22.2549 19.1393L27.9801 24.337L22.2588 30.5722Z' fill='#090A0A' />
            <path d='M32.9833 29.4731L27.2583 24.2754L32.9796 18.0407L38.7046 23.2384L32.9833 29.4731Z'
                  fill='#090A0A' />
            <path d='M70.3501 67.8436L64.625 62.6459L70.3463 56.4107L76.0713 61.6084L70.3501 67.8436Z' fill='#090A0A' />
            <path
              d='M10.2808 58.7799C4.51276 58.7799 0.191024 54.5638 0.00617522 48.7549C-0.211154 41.9367 5.22538 35.3948 11.879 34.4668L22.082 33.0466L22.1346 41.1521L10.7049 42.7429C9.68174 42.9037 8.74941 43.4241 8.07531 44.2108C7.40121 44.9975 7.02954 45.9989 7.02708 47.0351C7.02089 47.5128 7.10955 47.987 7.28788 48.4302C7.46621 48.8734 7.73069 49.2768 8.06598 49.617C8.40128 49.9572 8.80069 50.2275 9.24115 50.4121C9.6816 50.5967 10.1543 50.6921 10.6319 50.6926C10.8107 50.6922 10.9893 50.6796 11.1664 50.6549L38.2967 46.8797L38.1925 30.8054L46.7643 29.6107L46.9205 53.7906L11.9239 58.6619C11.3795 58.7389 10.8306 58.7783 10.2808 58.7799Z'
              fill='#090A0A' />
          </g>
          <defs>
            <clipPath id='clip0_2_135'>
              <rect width='168' height='92' fill='white' />
            </clipPath>
          </defs>
        </svg>

      </div>
      <!--      vendor name -->
      <div class='print-order-doc__header__vendor' v-if='detail.vendor'>
        {{ detail.vendor.name }}
      </div>

      <div class='print-order-doc__header__no'>

        <div class='print-order-doc__header__title'>
          #{{ detail.no }}
        </div>
        <div class='print-order-doc__header__date'>
          {{ formatDate(detail.date) }}
        </div>
      </div>

    </div>


    <!--      customer info-->
    <div class='print-order-doc__header__customer'>
      <div class='tile-flex'>
        <div class='tile-flex__title'>
          {{ $t('print.customer') }}
        </div>
        <div class='tile-flex__value'>
          {{ detail.user_name }}
        </div>
      </div>

      <div class='tile-flex'>
        <div class='tile-flex__title'>
          {{ $t('print.payment') }}
        </div>
        <div class='tile-flex__value'>
          {{ detail.payment.method }}
        </div>
      </div>

    </div>

    <table class='print-order-doc__table'>
      <thead>
      <tr class='print-order-doc__table__header'>
        <th>{{ $t('print.product') }}</th>
        <th>{{ $t('print.unit_price') }}</th>
        <th>{{ $t('print.qty') }}</th>
        <th>{{ $t('print.price') }}</th>
      </tr>
      </thead>
      <tbody class='print-order-doc__table__body'>
      <tr v-for='(item, index) in detail.order' :key='index'>
        <td>{{ item.name }}
          <!--          "options": [-->
          <!--          {-->
          <!--          "id": 41957,-->
          <!--          "name": "\u062f\u0628\u0644",-->
          <!--          "price_calc_mechanism": 0,-->
          <!--          "option_group_id": 22174,-->
          <!--          "price": 500-->
          <!--          },-->
          <!--          {-->
          <!--          "id": 41961,-->
          <!--          "name": "\u0635\u063a\u064a\u0631",-->
          <!--          "price_calc_mechanism": 1,-->
          <!--          "option_group_id": 22176,-->
          <!--          "price": 2000-->
          <!--          }-->
          <!--          ],-->
          <!--          addons-->
          <span v-if='item.options.length>0'>-
            <span v-for='(addon, index) in item.options' :key='index'>
              {{ addon.name }}
              <span v-if='index < item.options.length - 1'>,</span>
            </span>
          </span>
        </td>
        <td>{{ item.price }}</td>
        <td>{{ item.quantity }}</td>
        <td>{{ item.total }}</td>
      </tr>

      </tbody>
    </table>

    <div class='border-container'>

      <div class='print-order-doc__total'>
        <div class='print-order-doc__total__title'>
          {{ $t('print.sum') }}
        </div>
        <div class='print-order-doc__total__value'>
          {{ formatNumber(orderPrice) }}
        </div>
      </div>
      <div class='print-order-doc__total'>
        <div class='print-order-doc__total__title'>
          {{ $t('print.delivery') }}
        </div>
        <div class='print-order-doc__total__value'>
          {{ formatNumber(deliveryPrice) }}
        </div>
      </div>

      <div class='print-order-doc__total'>
        <div class='print-order-doc__total__title'>
          {{ $t('print.fee') }}
        </div>
        <div class='print-order-doc__total__value'>
          {{ formatNumber(feePrice) }}
        </div>
      </div>

      <div class='print-order-doc__discount'>
        <div class='print-order-doc__discount__title'>
          {{ $t('print.discount') }}
        </div>
        <div class='print-order-doc__discount__value'>
          {{ formatNumber(orderDiscount) }}
        </div>
      </div>

      <div class='print-order-doc__total'>
        <div class='print-order-doc__total__title'>
          {{ $t('print.coupon_discount') }}
        </div>
        <div class='print-order-doc__total__value'>
          {{ formatNumber(couponDiscount) }}
        </div>
      </div>
      <div class='print-order-doc__total small'>
        <div class='print-order-doc__total__title'>
          {{ $t('print.coupon_order_discount') }}
        </div>
        <div class='print-order-doc__total__value'>
          {{ formatNumber(couponOrderDiscount) }}
        </div>
      </div>
      <div class='print-order-doc__total small'>
        <div class='print-order-doc__total__title'>
          {{ $t('print.coupon_delivery_discount') }}
        </div>
        <div class='print-order-doc__total__value'>
          {{ formatNumber(couponDeliveryDiscount) }}
        </div>
      </div>

    </div>

    <div class='border-container border-1' style='margin-top: 1rem;margin-bottom: 1rem'>

      <div class='print-order-doc__total'>
        <div class='print-order-doc__total__title'>
          {{ $t('print.total') }}
        </div>
        <div class='print-order-doc__total__value'>
          {{ formatNumber(orderTotal) }}
        </div>
      </div>

    </div>

    <div class='print-order-doc__footer'>
      {{ $t('print.footer') }}

    </div>

  </div>

</template>

<script>

import { mapGetters } from 'vuex';

export default {

  computed: {
    ...mapGetters({
      detail: 'vendor/orders/getDetail'
    }),

    orderPrice() {
      return this.detail.bill.order.price;
    },

    deliveryPrice() {
      return this.detail.bill.delivery.price;
    },
    feePrice() {
      return this.detail.bill.service.price;
    },

    orderDiscount() {
      let dis = this.detail.bill.order.dis_price;
      if (this.detail.bill.coupon.order_discount)
        return (dis + this.detail.bill.coupon.order_discount);
      else
        return dis;
    },
    couponDiscount() {
      return (this.detail.bill.coupon.price)
    },
    couponDeliveryDiscount() {
      return (this.detail.bill.coupon.delivery_discount)
    },
    couponOrderDiscount() {
      return (this.detail.bill.coupon.order_discount)
    },
    orderTotal() {
     return this.detail.total_price;
    }


  }


};
</script>
<style>

</style>